<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card flat class="text-xs-center" width="100%">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Búsqueda de Contrarecibos</span>
                    </v-card-title>
                    <v-card-text>
                        <br />

                        <v-row justify="center">
                            <v-radio-group v-model="Buscar" row>
                                <v-radio label="Buscar por folio"
                                         value="2"></v-radio>
                                <v-radio label="Buscar por contrarecibo"
                                         value="3"></v-radio>
                                <v-radio label="Buscar por Nombre"
                                         value="4"></v-radio>
                                <v-radio label="Buscar por Razón Social"
                                         value="5"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-form ref="form" v-model="validForm" lazy-validation>
                            <v-row justify="center" v-if="Buscar != 0">
                                <v-col cols="12" md="4">

                                    <span>Contrarecibo: </span>
                                    <v-text-field v-model="contrarecibo" v-if="Buscar == 2 || Buscar == 3"
                                                  :rules="Buscar == 2 || Buscar == 3 ? [rules.numero] : ''"
                                                  outlined
                                                  autofocus
                                                  dense
                                                  v-on:blur="contrarecibo = contrarecibo.trim()"
                                                  @keydown.enter="Procesar($event)">
                                    </v-text-field>
                                    <v-text-field v-model="contrarecibo" v-if="Buscar == 4 || Buscar == 5"
                                                  :rules="Buscar == 4 || Buscar == 5 ? [rules.texto] : ''"
                                                  outlined
                                                  autofocus
                                                  dense
                                                  v-on:blur="contrarecibo = contrarecibo.trim()"
                                                  @keydown.enter="Procesar($event)">
                                    </v-text-field>

                                </v-col>
                            </v-row>
                        </v-form>

                        <v-row>
                            <v-col cols="12" md="12">
                                <DataTable v-if="contra" :url="url"
                                           :columns="head"
                                           :params="displayInputs"
                                           :formatterActions="formatterActions"
                                           :order="[[0, 'desc']]"
                                           @apiDT="apiDT = $event">
                                </DataTable>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
                <div v-show="showLightbox">
                    <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                              @onClosed="CerrarVisor()" />
                </div>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import finanzas from '@/services/Finanzas/finanzas.service.js';
    import LightBox from '@/components/pages/Visor/LightBox.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable,
            LightBox,
        },
        data() {
            return {
                validForm: true,
                showcargando: false,
                Buscar: 0,
                contrarecibo: '',
                contra: false,
                rules: {
                    required: value => !!value || 'Por favor selecciona el tipo de búsqueda o ingresa el valor requerido',
                    numero: (value) => /^[0-9|\/]*$/g.test(value) || 'Ingresa solo valores númericos.',
                    texto: (value) => /^[a-zA-Z ]{1,254}$/g.test(value) || 'No permite números, ingresa solo letras.',
                },
                apiDT: null,
                displayInputs: {},
                url: "Finanzas/ObtenerContrarecibos",
                head: [
                    { name: "facid", data: "facid", title: "Contrarecibo", },
                    { name: "prnombre", data: "prnombre", title: "Proveedor" },
                    { name: "facserie", data: "facserie", title: "Serie" },
                    { name: "faccfd", data: "faccfd", title: "CFD" },
                    { name: "prclave", data: "prclave", title: "Documento", formatter: [this, "formatearVer"], orderable: false },
                ],
                formatterActions: [
                    { click: [this, "VerArchivo"] },
                    { click: [this, "VerXML"] },
                    { click: [this, "VerArchivopdf"] },
                ],

                sPDF: false,
                media: [{
                    src: '@/',
                    type: ''
                }],
                showLightbox: false,
                overlay: false,
            }
        },
        methods: {
            async VerXML(params, datos) {
                this.showcargando = true;
                let formdata = new FormData();
                formdata.append("facid", datos.facid);
                formdata.append("doclave", 240)
                await finanzas.VisualizarXML(formdata).then(async response => {
                    if (response.msg != 'El archivo no se encontro') {
                        var link = document.createElement('a');
                        link.href = response.msg;
                        link.download = response.archivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        this.$swal(
                            "Éxito",
                            "El archivo xml se descargó correctamente",
                            'success'
                        );
                    }
                    else {
                        this.$swal(
                            "Atención",
                            'El archivo no se encontró',
                            'info'
                        );
                    }
                    this.showcargando = false;
                });

            },
            async VerArchivopdf(params, datos) {
                this.showcargando = true;
                this.showcargando = true;
                let formdata = new FormData();
                formdata.append("facid", datos.facid);
                formdata.append("doclave", 240)
                let dir = await finanzas.VisualizarArchivo(formdata);
                if (dir.error == false) {
                    const xhr = new XMLHttpRequest();
                    xhr.open('GET', dir.msg);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        const blob = new Blob([xhr.response], { type: 'application/pdf' });
                        const anchor = document.createElement('a');
                        anchor.href = URL.createObjectURL(blob);
                        anchor.download = dir.archivo;
                        document.body.appendChild(anchor);
                        anchor.click();
                    };
                    xhr.send();
                    this.$swal(
                        "Éxito",
                        "El archivo pdf se descargó correctamente",
                        'success'
                    );
                }
                else {
                    this.$swal(
                        "Atención",
                        'El archivo no se encontró',
                        'info'
                    );
                }
                this.showcargando = false;
            },
            async CerrarVisor() {
                var img = {
                    src: '@/',
                    type: 'img'
                }
                this.media = [];
                this.media.push(img);
                this.showLightbox = false;
                await this.$refs.lightbox.showImage(0);
            },
            async VerArchivo(params, datos) {
                let formdata = new FormData();
                formdata.append("facid", datos.facid);
                formdata.append("doclave", 240)
                let dir = await finanzas.VisualizarArchivo(formdata);
                this.showLightbox = false;
                this.overlay = true;
                this.media = this.media.filter(obj => obj.src == '@/');
                this.isPDF = /\.pdf$/i.test(dir.archivo);

                if (dir.error !== true) {
                    var img = {
                        src: dir.watch,
                        caption: '<h4>' + dir.archivo + '</h4>',
                        type: this.isPDF == true ? 'pdf' : 'img',
                        width: '800px',
                        //docid: datos.docid,
                        paginas: 1
                    };
                    this.media.push(img);
                    this.media = this.media.filter(obj => obj.src !== '@/');
                    this.showLightbox = true;
                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'info',
                        title: 'Error',
                        text: 'El archivo no se encontró',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    this.verarchi = false;
                }
                this.overlay = false;
            },
            formatearVer(data) {
                return data.prclave ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small primary dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${data.facid}" title="Ver Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-search-outline theme--dark"></i></span></button>` + //file-search-outline  mdi-file-pdf-box
                    `<button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small success dt-formatterAction" aria-haspopup="true" data-action="2" data-params="${data.facid}" title="Descargar Archivo pdf" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-file-pdf-box theme--dark"></i></span></button>` +
                    `<button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${data.facid}" title="Descargar Archivo xml" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-xml theme--dark"></i></span></button></div>` : ``;
            },
            Procesar(event) {

                this.contrarecibo = this.contrarecibo.trim()
                event.preventDefault();
                if (this.contrarecibo != '') {
                    if (this.$refs.form.validate()) {
                        this.contra = true;
                        this.displayInputs = {
                            tipo: this.Buscar,
                            dato: this.contrarecibo
                        };
                    }
                }

                
            }
        },
        watch: {
            'Buscar'(val) {
                if (this.Buscar != 0)
                    this.$refs.form.reset();
                else
                    this.Buscar = 0;
            }
        },
        async mounted() {
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '295').then(response => {

                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
    }
</script>